import { Row } from '@tanstack/react-table';
import React, { useCallback, useMemo } from 'react';

import { IPairBot } from 'types/bots';
import { IDexPair } from 'types/pairs';
import { IWalletTableRow } from 'types/tables/dex/walletTableRow';

import { PairTableConnectedBots } from './PairTableConnectedBots';

interface IConnectedBotsProps {
  meta: any;
  row: Row<IWalletTableRow>;
  dexPair: IDexPair;
}

export const ConnectedBots: React.FC<IConnectedBotsProps> = React.memo(({ meta, row, dexPair }) => {
  const { setRecords } = useMemo(() => meta, [meta]);
  const connectedBots = useMemo(() => row.original.connectedBotsCol?.row.connected_bots, [row]);
  const walletId = useMemo(() => row.original.id, [row]);

  const onChangeConnectedBots = useCallback(
    (new_connected_bots: IPairBot[]) => {
      setRecords((records: any) => {
        const newRecords = records === undefined ? [] : [...records];
        const botIndexOf = newRecords.findIndex(el => el.id === row.original.id);

        newRecords[botIndexOf] = {
          ...newRecords[botIndexOf],
          connected_bots: new_connected_bots,
        };

        return newRecords;
      });
    },
    [row.original.id, setRecords],
  );

  return (
    <PairTableConnectedBots
      connected_bots={connectedBots}
      pair={dexPair}
      walletId={walletId}
      onChangeConnectedBots={onChangeConnectedBots}
    />
  );
});
